export default __webpack_public_path__ + "static/media/sticker.75dd4f38.png";